<template>
    <p
        class="text-sm text-secondary"
        data-spec-class="card-content"
    >
        <slot />
    </p>
</template>
